const AUTO_START_PREFIX = "relance:auto-start-interview:";

function canUseSessionStorage() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

function getAutoStartKey(interviewId: string) {
  return `${AUTO_START_PREFIX}${interviewId}`;
}

export function markPendingInterviewAutoStart(interviewId: string) {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(getAutoStartKey(interviewId), "1");
}

export function hasPendingInterviewAutoStart(interviewId: string) {
  if (!canUseSessionStorage()) {
    return false;
  }

  return window.sessionStorage.getItem(getAutoStartKey(interviewId)) === "1";
}

export function consumePendingInterviewAutoStart(interviewId: string) {
  if (!canUseSessionStorage()) {
    return false;
  }

  const key = getAutoStartKey(interviewId);
  const shouldAutoStart = window.sessionStorage.getItem(key) === "1";
  if (shouldAutoStart) {
    window.sessionStorage.removeItem(key);
  }

  return shouldAutoStart;
}
